import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "subtitle" }
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "form-title" }
const _hoisted_4 = { class: "error-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString(_ctx.selectedSite?.description), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('reclamation.description.title')), 1),
      _createElementVNode("div", {
        class: _normalizeClass(["description-container", _ctx.error ? 'description-container-error' : ''])
      }, [
        _withDirectives(_createElementVNode("textarea", {
          onFocus: _cache[0] || (_cache[0] = ($event: any) => (this.focus = true)),
          onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
          class: "description-input",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputValue) = $event)),
          name: "description",
          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
        }, null, 544), [
          [_vModelText, _ctx.inputValue]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["label", `${_ctx.error ? 'label-error' : ''} ${_ctx.focus || _ctx.inputValue ? 'label-active' : ''}`])
        }, _toDisplayString(_ctx.$t('reclamation.description.label')), 3)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", null, _toDisplayString(_ctx.error), 1)
      ])
    ])
  ], 64))
}